import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class SiteParameterAPI {

    constructor(http) {
        this.http = http
    }

    getList(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);
    
        });

        

        this.http.get('api/admin/siteParameter/getList')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("parameters"))
                        successCallback(json.parameters);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    save(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);
    
        });

        

        this.http.post('api/admin/siteParameter/save', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("parameters"))
                        successCallback(json.parameters);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getPrivacyPolicy(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);
    
        });

        

        this.http.get('api/admin/siteParameter/getPrivacyPolicy')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("parameters"))
                        successCallback(json.parameters);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    setPrivacyPolicy(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);
    
        });

        

        this.http.post('api/admin/siteParameter/setPrivacyPolicy', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("parameters"))
                        successCallback(json.parameters);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    
    getPublicPrivacyPolicy(data, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json');
        });

        

        this.http.post('api/wlusers/getPublicPrivacyPolicy', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("parameters"))
                        successCallback(json.parameters);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getPublicTermsConditions(data, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json');
        });

        

        this.http.post('api/wlusers/getPublicTermsConditions', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("parameters"))
                        successCallback(json.parameters);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    
                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
}